<template>
  <div class="number-condition">
    <el-select class="ml-3" v-model="condition" size="small">
      <el-option v-for="item in conditions" :key="item.value" :value="item.value" :label="item.label" />
    </el-select>
  </div>
</template>

<script>
import { EQ, LT, LE, NOT_EQ, NOT_NULL, NULL, GT, GE, BETWEEN, NOT_BETWEEN } from '@/assets/js/config/condition-config'

export default {
  name: 'NumberCondition',
  data() {
    return {
      conditions: [
        {
          label: '等于',
          value: EQ
        },
        {
          label: '不等于',
          value: NOT_EQ
        },
        {
          label: '大于',
          value: GT
        },
        {
          label: '大于等于',
          value: GE
        },
        {
          label: '小于',
          value: LT
        },
        {
          label: '小于等于',
          value: LE
        },
        {
          label: '介于（含等于）',
          value: BETWEEN
        },
        {
          label: '不介于',
          value: NOT_BETWEEN
        },
        {
          label: '为空',
          value: NULL
        },
        {
          label: '不为空',
          value: NOT_NULL
        }
      ]
    }
  }
}
</script>

<style scoped></style>
